import carIcon from "../../assets/iconos/car.png"
import { TIPO_USUARIO_WEB } from "../../utils/const/int-const";

export const MODULOS_ADMINISTRACION = [
    {
        id: 0,
        titulo: 'Gestionar Empresa',
        descripcion: 'Datos Empresa',
        icono: carIcon,
        color: 'rgba(0, 128, 0, 0.5)',
        href: 'administracion/gestionar-empresa/empresa',
        tipoUsuario: TIPO_USUARIO_WEB.REGULAR,
    },
    {
        id: 1,
        titulo: 'Gestionar Vehiculos',
        descripcion: 'Datos Vehiculos/Unidades',
        icono: carIcon,
        color: 'rgba(0, 128, 0, 0.5)',
        href: 'administracion/gestionar-vehiculos/listar-vehiculos',
        tipoUsuario: TIPO_USUARIO_WEB.REGULAR,
    },
    {
        id: 2,
        titulo: 'Gestionar Conductores',
        descripcion: 'Datos Conductores',
        icono: carIcon,
        color: 'rgba(0, 128, 0, 0.5)',
        href: 'administracion/gestionar-conductores/listar-conductores',
        tipoUsuario: TIPO_USUARIO_WEB.REGULAR,
    },
    {
        id: 3,
        titulo: 'Gestionar Usuario Movil',
        descripcion: 'Usuario Movil',
        icono: carIcon,
        color: 'rgba(0, 128, 0, 0.5)',
        href: 'administracion/gestionar-usuario-movil/listar-usuario-movil',
        tipoUsuario: TIPO_USUARIO_WEB.REGULAR,
    },
    {
        id: 4,
        titulo: 'Gestionar Categoria',
        descripcion: 'Categorias que se pueden usar para organizar los productos',
        icono: carIcon,
        color: 'rgba(0, 128, 0, 0.5)',
        href: 'administracion/gestionar-categoria/listar-categorias',
        tipoUsuario: TIPO_USUARIO_WEB.REGULAR,
    },
    {
        id: 5,
        titulo: 'Gestionar Productos',
        descripcion: 'Listado de Productos',
        icono: carIcon,
        color: 'rgba(0, 128, 0, 0.5)',
        href: 'administracion/gestionar-producto/listar-productos',
        tipoUsuario: TIPO_USUARIO_WEB.REGULAR,
    },
    {
        id: 6,
        titulo: 'Gestionar Ciudades',
        descripcion: 'Listado de Ciudades',
        icono: carIcon,
        color: 'rgba(0, 128, 0, 0.5)',
        href: 'administracion/gestionar-ciudades/listar-ciudades',
        tipoUsuario: TIPO_USUARIO_WEB.REGULAR,
    },
    {
        id: 7,
        titulo: 'Gestionar Vendedores',
        descripcion: 'Listado de Vendedores',
        icono: carIcon,
        color: 'rgba(0, 128, 0, 0.5)',
        href: 'administracion/gestionar-vendedores/listar-vendedores',
        tipoUsuario: TIPO_USUARIO_WEB.REGULAR,
    },
    {
        id: 8,
        titulo: 'Gestionar Combustible',
        descripcion: 'Listado Combustible',
        icono: carIcon,
        color: 'rgba(0, 128, 0, 0.5)',
        href: 'administracion/gestionar-combustible/listar-combustible',
        tipoUsuario: TIPO_USUARIO_WEB.SUPER_ADMIN,
    },
    {
        id: 9,
        titulo: 'Gestionar Tipo Vehiculo',
        descripcion: 'Listado Tipo Vehiculo',
        icono: carIcon,
        color: 'rgba(0, 128, 0, 0.5)',
        href: 'administracion/gestionar-tipo-vehiculo/listar-tipo-vehiculo',
        tipoUsuario: TIPO_USUARIO_WEB.SUPER_ADMIN,
    },
    {
        id: 10,
        titulo: 'Gestionar Voltaje Bateria',
        descripcion: 'Listado Voltaje Bateria',
        icono: carIcon,
        color: 'rgba(0, 128, 0, 0.5)',
        href: 'administracion/gestionar-voltaje-bateria/listar-voltaje-bateria',
        tipoUsuario: TIPO_USUARIO_WEB.SUPER_ADMIN,
    },
    {
        id: 11,
        titulo: 'Gestionar Rol',
        descripcion: 'Rol del Usuario Movil',
        icono: carIcon,
        color: 'rgba(0, 128, 0, 0.5)',
        href: 'administracion/gestionar-rol/listar-roles',
        tipoUsuario: TIPO_USUARIO_WEB.REGULAR,
    },
];